export class ApiResponseUtilities {
 
    public static isSuccessStatusCode(statusCode?: number) : boolean {
        if (!statusCode) {
            return false;
        }
        return statusCode >= 200 && statusCode < 300;
    }

    public static isClientErrorStatusCode(statusCode?: number) : boolean {
        if (!statusCode) {
            return false;
        }
        return statusCode >= 400 && statusCode < 500;
    }

    public static isServerErrorStatusCode(statusCode?: number) : boolean {
        if (!statusCode) {
            return false;
        }
        return statusCode >= 500 && statusCode < 600;
    }

    public static isNotFoundStatusCode(statusCode?: number) : boolean {
        if (!statusCode) {
            return false;
        }
        return statusCode === 404;
    }

    public static isConflictStatusCode(statusCode?: number) : boolean {
        if (!statusCode) {
            return false;
        }
        return statusCode === 409;
    }

    public static IsInternalServerErrorStatusCode(statusCode?: number) : boolean {
        if (!statusCode) {
            return false;
        }
        return statusCode === 500;
    }

    public static isRedirection(statusCode?: number): boolean {
        if (!statusCode) {
            return false;
        }
        return statusCode >= 300 && statusCode < 400;
    }

    
}
 